import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1176b8', // Blue
      contrastText: '#fff', // White
    },
    secondary: {
      main: '#CCC', // Yellow
      contrastText: '#000',
    },
  },
  typography: {
    // Sets the font throughout the application.  Requires using Material UI typography component.
    fontFamily: ['Helvetica', 'Maven Pro', 'Roboto'].join(','),
  },
});



// WEBPACK FOOTER //
// ./src/theme/index.js